var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "schedule_icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "schedule_icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6385857,8.41694647 L21.2215693,8.41694647 L20.2771715,8.41694647 L12.721989,8.41694647 L11.7775912,8.41694647 L10.3614143,8.41694647 C9.05940447,8.41694647 8,9.47629864 8,10.7782441 L8,21.6387024 C8,22.9406478 9.05940447,24 10.3614143,24 L22.6385857,24 C23.9405955,24 25,22.9406478 25,21.6387024 L25,13.1387024 L25,12.1943512 L25,10.7774047 C24.9991605,9.47545921 23.9397561,8.41694647 22.6385857,8.41694647 Z",
    id: "Shape",
    fill: "#0CAEFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun_Calendar_684828",
    transform: "translate(6.000000, 5.000000)",
    fill: "#0172D4",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.499679,1.50029627 L13.9993087,1.50029627 L13.9993087,0 L12.9993581,0 L12.9993581,1.50029627 L4.9997531,1.50029627 L4.9997531,0 L3.99980248,0 L3.99980248,1.50029627 L2.50032097,1.50029627 C1.12172238,1.50029627 0,2.62196326 0,4.00049378 L0,15.4998025 C0,16.878333 1.12172238,18 2.50032097,18 L15.499679,18 C16.8782776,18 18,16.878333 18,15.4998025 L18,6.49980249 L18,5.49990124 L18,3.99960498 C17.9991112,2.62107446 16.8773888,1.50029627 15.499679,1.50029627 Z M16.9991605,15.4989137 C16.9991605,16.3254987 16.3263049,16.9983212 15.499679,16.9983212 L2.50032097,16.9983212 C1.67280628,16.9983212 0.99995062,16.3254987 0.99995062,15.4989137 L0.99995062,6.49980249 L16.9991605,6.49980249 L16.9991605,15.4989137 Z M16.9991605,5.49990124 L0.99995062,5.49990124 L0.99995062,3.99960498 C0.99995062,3.17213115 1.67280628,2.49930871 2.50032097,2.49930871 L4.00069132,2.49930871 L4.00069132,3.49920995 L4.9997531,3.49920995 L4.9997531,2.50019751 L12.9993581,2.50019751 L12.9993581,3.50009876 L13.9993087,3.50009876 L13.9993087,2.50019751 L15.499679,2.50019751 C16.3263049,2.50019751 16.9991605,3.17213115 16.9991605,3.99960498 L16.9991605,5.49990124 Z",
    id: "Shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.a2377ff7.svg";
export { ForwardRef as ReactComponent };